import React, { Component } from 'react';
import * as util from './util';
import { defaultHeaders } from './util';
import {Header} from './header.js';
import './editor.css';
import {Footer} from './footer.js';
import './requirement.css';

let faqRequirements = [];

export class Requirements extends Component {
  constructor(props) {
    super(props);
    this.getRequirementsContent = this.getRequirementsContent.bind(this);
    this.state = {
      staticHTML : ''
    }
  }

  componentWillMount() {
    this.getRequirementsContent();
  }

  getRequirementsContent() {
    const self = this;
    const url = `/api/get-editor-content?type=requirements`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        alert('Aktuelle gesetzliche Anforderung konnten nicht geladen werden.');
        console.error('Could not fetch requirements content.', exception);
      });
    promise.then(function (json) {
      self.setState({
        staticHTML : json.text.requirements
      });
      return;
    });
    return;
  }

  render() {
    if (util.isGuestUser()) {
      return (
        <div className="Landing">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">

              <div className="contentHeaderText">
                Für nicht eingeloggte Nutzer ist die Seite nicht sichtbar.
           </div>
            </div>
          </div>


          {/*  <InfoBar faq={faqRequirements} />*/}
        </div>
      )
    } else {
      return (
        <div className="Landing">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">

              <div className="contentHeaderText">
                  Aktuelle gesetzliche Anforderungen 
              </div>
              <div className="requirements">
              <div className="marginTop30" dangerouslySetInnerHTML={{ __html: this.state.staticHTML }} ></div>
         {/* <InfoBar faq=>{faqRequirements} />*/}
            </div>
            </div>
            </div>
          <Footer faqs={faqRequirements}/>
          </div>
      
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/requirements.js